import React from 'react';
import { Empty } from '@tinper/next-ui';
import { ConfigConsumer } from './context';

const renderEmpty = (componentName) => (
  <ConfigConsumer>
    {({ getPrefixCls }) => {
      // const prefix = getPrefixCls('empty');

      switch (componentName) {
      default:
        return <Empty />;
      }
    }}
  </ConfigConsumer>
);

export default renderEmpty;
